function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFundClass, getProductTypeLabel, getFundsCategoryPath, getProductTypeById } from '@finect/front-resources/Products';
import { ManagementCompany, QuoteLabel, AssetsLabel } from '../../../Products';
import { Stars } from '../../../Stars';
import { CellPlusAction } from '../CellPlusAction';
import { CellFund } from '../CellFund';
import { ProductDistributors } from '../../../Products/ProductsTable/ProductRow/ProductDistributors';
import { ESGRating } from '../../../Products/ProductsTable/ProductRow/ESGRating';
import { BuyButton } from '../../../Products/ProductsTable/ProductRow/BuyButton';
import { empty } from './empty';
import { MIN_PRODUCTS, getPlaceholdersQty } from './configs';
export var getMetaRows = function getMetaRows(theme, productType, funds, inPill, onAction, getSheetPath, addFundAction, deleteFundAction, onChangeClass) {
  var emptyMetaRows = empty(getPlaceholdersQty(funds, MIN_PRODUCTS)).map(function () {
    return React.createElement("span", {
      key: "c1"
    }, "\u2014");
  });
  var emptyAddActionMetaRows = empty(getPlaceholdersQty(funds, MIN_PRODUCTS)).map(function () {
    return React.createElement(CellPlusAction, {
      onClick: addFundAction,
      key: "pa1"
    });
  });
  var metaRows = [[productType ? productType.shortSingular : 'Producto'].concat(_toConsumableArray(funds.map(function (fund, index) {
    var fundProductType = productType ? productType : getProductTypeById(fund.subtype);
    return React.createElement(CellFund, {
      key: index,
      productType: fundProductType,
      index: index + 1,
      getSheetPath: getSheetPath,
      fund: fund,
      onDeleteAction: !inPill ? function () {
        return deleteFundAction(fund);
      } : null,
      onChangeClass: !inPill ? function () {
        return onChangeClass(fund);
      } : null
    });
  }))), [productType && productType.id === 'plan' ? 'Código DGS PP' : 'ISIN'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement("span", {
      key: "isin"
    }, fund.isin);
  }))), [''].concat(_toConsumableArray(funds.map(function (fund, index) {
    return React.createElement(BuyButton, {
      key: index,
      product: _objectSpread(_objectSpread({}, fund), {}, {
        entity: fund
      }),
      onAction: onAction ? function () {
        return onAction({
          subtype: fund.subtype,
          entity: fund
        });
      } : function () {},
      variant: "button"
    });
  }))), ['Distribuido por:'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(ProductDistributors, {
      key: "distributors",
      entity: fund,
      qty: 4
    });
  }))), ['Valoración'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(Stars, {
      key: "stars",
      value: fund.score,
      size: "small"
    });
  }))), ['Rating de sostenibilidad'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement(ESGRating, {
      key: "esg",
      value: fund.stats.ESG
    });
  }))), ['Valor liquidativo'].concat(_toConsumableArray(funds.map(function (fund) {
    var _fundClass$currency;
    var fundClass = getFundClass(fund);
    return React.createElement(QuoteLabel, {
      key: "nav",
      value: fund.lastQuote.price,
      currency: (_fundClass$currency = fundClass.currency) === null || _fundClass$currency === void 0 ? void 0 : _fundClass$currency.code,
      decimals: 2
    });
  }))), ['SRRI'].concat(_toConsumableArray(funds.map(function (fund) {
    return React.createElement("span", {
      key: "srri"
    }, fund.srri ? React.createElement("span", null, fund.srri) : React.createElement("span", null, "\u2014"));
  }))), ['Gestora'].concat(_toConsumableArray(funds.map(function (fund) {
    var fundProductType = productType ? productType : getProductTypeById(fund.subtype);
    return React.createElement(ManagementCompany, {
      key: "ManagementCompany",
      variant: "link",
      managementCompany: fund.managementCompany,
      productType: fundProductType
    });
  }))), ['Categoría'].concat(_toConsumableArray(funds.map(function (fund) {
    var fundProductType = productType ? productType : getProductTypeById(fund.subtype);
    return fund.category ? React.createElement(AppLink, {
      key: "category",
      href: getFundsCategoryPath(theme, fundProductType, fund.category),
      title: "Ver ".concat(getProductTypeLabel(fundProductType, 'shortPlural', 'lowercase'), " de la categor\xEDa ").concat(fund.category.name)
    }, fund.category.name) : React.createElement("span", {
      key: "c1"
    }, "\u2014");
  }))), ['Patrimonio'].concat(_toConsumableArray(funds.map(function (fund) {
    var _fundClass$currency2;
    var fundClass = getFundClass(fund);
    return React.createElement(AssetsLabel, {
      key: "assets",
      value: fund.totalNetAsset,
      scale: "million",
      currency: (_fundClass$currency2 = fundClass.currency) === null || _fundClass$currency2 === void 0 ? void 0 : _fundClass$currency2.code
    });
  })))];
  if (!inPill) {
    metaRows.map(function (meta, index) {
      return !index ? meta.push.apply(meta, _toConsumableArray(emptyAddActionMetaRows)) : meta.push.apply(meta, _toConsumableArray(emptyMetaRows));
    });
  }
  return metaRows;
};